import { defineStore } from 'pinia'

import { ApplicationMessageList, SingleConversationContext } from '@frontapp/plugin-sdk';

type Platform = 'front' | 'missive' | 'browser';

interface ContextStore {
  platform: Platform
  messages: ApplicationMessageList
  frontContext: SingleConversationContext
  isOrphanConversation: null | boolean,
  user: {
    frontId: string
    email: string
    fullName: string
  }
}

const useContextStore = defineStore("ContextStore", {
  state: () : ContextStore => {
    return {
      platform: 'browser',
      messages: null as any,
      frontContext: null as any,
      /** This is a quick fix allowing us to continue using the ClaimStore() while searching for claims to link to the orphan conversation */
      isOrphanConversation: null,
      user: {
        email: "",
        fullName: "",
        frontId: ""
      }
    }
  },
  actions: {
    async storeFrontMessages(frontContext: SingleConversationContext) {
      this.messages = await frontContext.listMessages();
    }
  },
  getters: {
    // isPlatformBrowser: (state) => false, // Front-plugin Dev
    isPlatformBrowser: (state) => state.platform === 'browser',
    adminLink: (state) => state.frontContext.conversation.links.find(l => l.externalUrl.startsWith("https://admin.upclaim.eu/claims/"))
  },
});

export default useContextStore;